import { createReducer } from 'typesafe-actions';
import { AuthAction, AuthState } from './types';
import { 
	SET_TOKEN,
	GET_USER,
	GET_USER_SUCCESS,
	GET_USER_ERROR,
	GET_ACCOUNT,
	GET_ACCOUNT_SUCCESS,
	GET_ACCOUNT_ERROR,
	LOGIN,
	LOGIN_SUCCESS,
	LOGIN_ERROR, 
	SET_USER,
	SET_ACCOUNT,
	SET_PLAN,
	SET_SERVICE,
} from './actions';

const initialState: AuthState = {
	token: undefined,
	user: {
		id: '',
		accountId: '',
		name: '',
		status: '',
		scope: '',
		hasStibeeNewsLetter: '',
		phoneNumber: '',
		isAuthorized: '',
		isAgreedSpamPolicy: '',
	},
	account: {
		id: '',
		key: '',
		isProfit: '',
		from: '',
		isTesting: false,
		isTestingPaid: false,
		isOld: '',
		memberRange: '',
		businessCategory: '',
		purpose: {
			purposeType: {
				id: ''
			},
			purposeValues: []
		},
		contentPolicy: {
			initialized: false,
			allowedMarketing: false,
			allowedShare: false,
			allowedRobots: false
		},
		billing: {
			subscriberCount: -1,
			availableCount: -1,
			plan: -1,
			currentPlan: -1,
			nextPlan: -1,
			billingType: -1,
			billingDate: '',
			renewalDate: '',
			smsCount: -1,
			lmsCount: -1
		},
		createdTime: ''
	},
	plan: {},
	service: {
		sponsor: false,
		isStarter: false,
		isLight: false,
		isStandard: false,
	}
};

const auth = createReducer<AuthState, AuthAction>(initialState, {
	[SET_TOKEN]: (state, action) => {		
		return {
			...state,
			token: action.payload
		}
	},
	[SET_USER]: (state, action) => {		
		return {
			...state,
			user: action.payload
		}
	},
	[SET_ACCOUNT]: (state, action) => {		
		return {
			...state,
			account: action.payload
		}
	},
	[SET_PLAN]: (state, action) => {		
		return {
			...state,
			plan: action.payload
		}
	},
	[GET_USER]: state => ({
		...state,
	}),
	[GET_USER_SUCCESS]: (state, action) => ({
		...state,
		user : action.payload,
	}),
	[GET_USER_ERROR]: (state, action) => ({
		...state,
	}),
	[GET_ACCOUNT]: state => ({
		...state,
	}),
	[GET_ACCOUNT_SUCCESS]: (state, action) => ({
		...state,
		account: action.payload,
	}),
	[GET_ACCOUNT_ERROR]: (state, action) => ({
		...state,
	}),
	[LOGIN]: state => ({
		...state,
		token: ''
	}),
	[LOGIN_SUCCESS]: (state, action) => ({
		...state,
		token: action.payload,
	}),
	[LOGIN_ERROR]: (state, action) => ({
		...state,
		token: ''
	}),
	[SET_SERVICE]: (state, action) => {		
		return {
			...state,
			service: action.payload
		}
	},
});

export default auth;